module.exports = "/_next/static/images/9143f9ba8305b83465d93fe21a3b7c1d-faded-graph-icon.svg.webp";